export function getPayerType(Ref: string): string {
  return payerTypeByRef[Ref];
}

export function getPaymentMethod(Ref: string): string {
  return paymentMethodByRef[Ref];
}

export const SenderPayerRef = 'b128d80b-70d6-11e8-9296-0025b502a04e';
export const RecipientPayerRef = 'b1295231-70d6-11e8-9296-0025b502a04e';

const payerTypeByRef: { [key: string]: string } = {
  [SenderPayerRef]: 'Відправник',
  [RecipientPayerRef]: 'Отримувач',
};

export const PaymentMethods = {
  NonCash: 'b12a784c-70d6-11e8-9296-0025b502a04e',
  Cash: 'b129ff5c-70d6-11e8-9296-0025b502a04e'
}

const paymentMethodByRef: { [key: string]: string } = {
  [PaymentMethods.NonCash]: 'Безготівкова',
  [PaymentMethods.Cash]: 'Готівкова',
}

export const IIEditButtonInitialState: boolean = false;
export const IIDeleteButtonInitialState: boolean = false;
